<script lang="ts">
	import {
		hoverState,
		hoveredXpos,
		hoveredYpos,
		originHoveredXpos,
		originHoveredYpos
	} from '../../stores/hover';
	//import type { Collection, Element, GameArray } from '../utils/types';

	import { gameStart } from '../../stores/winState';
	import { fade, fly } from 'svelte/transition';
	import { afterUpdate, onMount } from 'svelte';
	import { tweened } from 'svelte/motion';
	import { COLS, ROWS, SymType } from '../../stores/settingsStore';
	import { CIRCLE_DIAMETER } from '../../utils/constants';
	import { LightenDarkenColor } from '../../utils/colors';
	import { transitionToActive } from '../../stores/gameState';
	import { element } from 'svelte/internal';

	export let x = 0;
	export let y = 0;
	//export let currentLevel = 0;

	onMount(() =>
		setTimeout(() => {
			$transitionToActive = true;
		}, 2000)
	);
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->

<div
	class="item-wrapper"
	on:mouseout={() => {
		//	if (!$hoverState) {
		//	winState();
		//	}
	}}
	on:mouseover={() => {
		if ($hoverState) {
			//console.log('continue');
			//onmouseover(x, y, $hoveredXpos, $hoveredYpos);
			//$tweenLeft = $hoveredXpos;
			$hoveredXpos = x;
			$hoveredYpos = y;
			//changeVariantElement();

			//addVariantElement(x, y);
		}
	}}
>
	<div in:fade={{ delay: 800 * (x / 200 + y / 10) }}>
		<slot />
	</div>
</div>

<style>
	.item-wrapper {
		position: relative;
		/* width: 150px;
		height: 50px; */

		perspective: 1200px;
		transform-style: preserve-3d;
	}

	/* .symmetrical-item {
		user-select: none;
		box-sizing: border-box;
		position: relative;
		top: 25px;
		width: 20px;
		height: 20px;
		border-radius: 10px;
		background-color: transparent;
		border: solid #1f1f1f 3px;
		z-index: 3;
	}

	.item {
		user-select: none;
		box-sizing: border-box;
		position: absolute;
		width: 50px;
		height: 50px;
		border: 1px solid black;
		z-index: 2;

		animation-duration: 1200ms;
		animation-fill-mode: forwards;
		animation-name: flip;
		transform-style: preserve-3d;
		backface-visibility: visible;
	} */

	@keyframes flip {
		0% {
			opacity: 0;
			transform: rotateX(0deg);
		}
		50% {
			opacity: 1;
			transform: rotateX(180deg);
		}
		100% {
			opacity: 1;
			transform: rotateX(0deg);
		}
	}
</style>
